export const emptyPackageForm = {
  id: null,
  package_name: '',
  price: '',
  duration_months: '',
  max_users: '',
  max_admins: '',
  max_workers: '',
  features: '',
  status: 'active',
};

export const formatCurrency = (value) => `Rs.${Number(value || 0).toLocaleString('en-IN')}`;

export const formatDate = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

export const getSeatLimit = (pkg) => Number(pkg.max_admins || 0) + Number(pkg.max_workers || 0);
